<template><div><h1 id="wahrung" tabindex="-1"><a class="header-anchor" href="#wahrung"><span>Währung</span></a></h1>
<p>Währung — Definiert Währungen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Tabelle definiert die gültigen Währungen im System sowie die aktuell gültigen Wechselkurse. Pro Währung können beliebig viele Wechselkurse mit einem Gültigkeitsdatum versehen hinterlegt werden.</p>
<p>Pfad: <code v-pre>Buchhaltung → Tabellen → Währungen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Währung</dt>
<dd>Kürzel der Währung, 3-stellig, alphanumerisch</dd>
<dt>Bezeichnung</dt>
<dd>Bezeichnung der Währung</dd>
<dt>LWhg</dt>
<dd>Landeswährung</dd>
<dt>Rundung</dt>
<dd>Rundung</dd>
<dt>MWST-Rundung</dt>
<dd>Rundung bei Mehrwertsteuer</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>N/A</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.whgpos.html" title="Währung Umrechnungskurse">Währungs-Position</RouteLink></p>
</div></template>


